<div class="py-2 mb-4 w-full border-b-[1px] transition-colors duration-200"
  [ngClass]="{'border-red-500 border-1 bg-red-50 rounded-lg px-2': error || reconciliation?.error}">
  <div class="grid grid-cols-5 gap-2 content-center">
    <div class="flex col-span-1 place-self-start p-2">
      <span class="text-sm text-gray-700">{{ reconciliation?.source1?.name }}</span>
    </div>

    <div class="flex items-center col-span-1">
      <input type="file" class="hidden" [id]="reconciliation?.source1?.id" [disabled]="isReconciling"
        (change)="onFileChange($event)" multiple accept="{{ getSourceFormat() }}" />
      <label [for]="reconciliation?.source1?.id" class="bg-gray-300 py-2 px-4 rounded "
        [class]="isReconciling? 'cursor-not-allowed opacity-50':  ''">
        {{ 'BATCH_LINE.LOAD' | translate }}
      </label>
    </div>
    @if (loading) {
    <div class="w-full bg-gray-200 rounded-full h-2 mt-2">
      <div class="bg-primary-800 h-2 rounded-full transition-all" [style.width.%]="uploadProgress"></div>
    </div>
    }

    @if (uploadProgress > 0 && uploadProgress < 100) { <p class="text-sm">
      ... {{ uploadProgress }}%
      </p>
      }

      @if (reconciliation.id && !loading) {
      <div class="flex flex-row items-center col-span-3">
        <div class="w-1/3 text-start">
          {{ totalFiles() }} {{ 'BATCH_LINE.FILES' | translate }}
        </div>
        <div class="w-1/3 flex justify-center">
          <app-status-badge [status]="reconciliation?.status"></app-status-badge>
        </div>
        <div class="w-1/3 text-center flex flex-row items-center space-x-4 justify-end">
          <button (click)="showReconciliation()" class="badge badge--secondary flex items-center">
            <app-icon-eye></app-icon-eye>
          </button>
          <button (click)="onShowFiles()" class="badge badge--secondary flex items-center">
            <app-icon-chevron></app-icon-chevron>
          </button>
        </div>
      </div>
      }
  </div>
  @if (error || reconciliation?.error) {
  <span class="text-red-700 font-semibold p-1 text-sm mt-2 flex items-center rounded">
    <i class="fa-solid fa-triangle-exclamation mr-2"></i>
    {{ error || reconciliation?.error }}
  </span>
  }
</div>
@if (showFiles()) {
<div class="py-1">
  @if (batchId) {
  <div class="w-full grid grid-cols-3 gap-4">
    @for(file of reconciliation.source1.sourcePaths; track file.path) {
    <app-display-file [filename]="file.path" [splitted]="true"></app-display-file>
    }
  </div>
  }
</div>
}

@if (reconciliation.children) {
@for (child of reconciliation.children; track child) {
<div class="p-2 w-full border-b-[1px] ml-4">
  <div class="flex flex-row items-center">
    <div class="basis-1/4 p-2" [class]="child?.source1?.type=== 'BUNDLE' ? 'pl-4 border-l-2 border-gray-400' : 'p-0'">
      <span class="text-sm text-gray-700">{{ child?.source1?.name }} ({{child?.externalSelectedFile?.length}} {{
        'BATCH_LINE.FILES' | translate }})</span>
    </div>
    @if (child.externalSelectedFile) {
    <div class="basis-3/4 grid grid-cols-3 gap-2">
      @for(file of child.externalSelectedFile; track file.path || file.name) {
      <app-display-file [filename]="file.path || file.name" [splitted]="true"></app-display-file>
      }
    </div>
    }
  </div>
</div>
}
}